import React, { PureComponent } from 'react'

import { ContentLoaderAwareOfRequestLoader } from 'components/_new/ui'


export default (ComposedComponent) =>

  class WrappedComponent extends PureComponent {

    static WrappedComponent = ComposedComponent

    static displayName = `contentLoader(${ComposedComponent.displayName || ComposedComponent.name})`

    static propTypes = ComposedComponent.propTypes

    state = {
      isLoaderVisible: true,
    }

    showLoader = () => {
      const { isLoaderVisible } = this.state

      if (!isLoaderVisible) {
        this.setState({
          isLoaderVisible: true,
        })
      }
    }

    hideLoader = () => {
      const { isLoaderVisible } = this.state

      if (isLoaderVisible) {
        this.setState({
          isLoaderVisible: false,
        })
      }
    }

    render() {
      const { isLoaderVisible } = this.state

      return (
        <div>
          {
            isLoaderVisible && (
              <ContentLoaderAwareOfRequestLoader />
            )
          }
          <ComposedComponent
            {...this.props}
            isLoaderVisible={isLoaderVisible}
            showLoader={this.showLoader}
            hideLoader={this.hideLoader}
          />
        </div>
      )
    }
  }
